import { useIsFetching, useIsMutating } from '@zg-rentals/react-query5';
import { useRecoilState } from 'recoil';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';

import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

import { useCancelSigningMutation } from '../../../utils/queries';

import { isEditLeaseExtensionModalOpenState } from '../../../../atoms';
import { CANCELLATION_REASON_LEASE_EXTENSION } from '../../../constants/stringConstants';
import { useLeasingUrlParams } from '../../../hooks';

export default function EditLeaseExtensionModal() {
  const [isEditLeaseExtensionModalOpen, setIsEditLeaseExtensionModalOpen] = useRecoilState(
    isEditLeaseExtensionModalOpenState,
  );
  const { renewalId } = useLeasingUrlParams();

  const isFetching = useIsFetching() > 0;
  const isMutating = useIsMutating() > 0;

  const cancelSigningMutation = useCancelSigningMutation();

  function onEditModalClose() {
    setIsEditLeaseExtensionModalOpen(false);
  }

  async function onYesEditClick() {
    await cancelSigningMutation.mutateAsync({
      postData: {
        leaseArtifactId: renewalId as unknown as number,
        leaseArtifactType: LeaseArtifactType.LEASE_EXTENSION_RENEWAL,
        message: CANCELLATION_REASON_LEASE_EXTENSION,
      },
    });
    setIsEditLeaseExtensionModalOpen(false);
  }

  return (
    <Modal
      size={{ base: 'fullScreen', md: 'sm' }}
      open={isEditLeaseExtensionModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          onEditModalClose();
        }
      }}
      header={<Heading level={1}>Edit your lease renewal?</Heading>}
      body={
        <Paragraph>
          Making changes will pause the signing and cancel any existing signatures. After you make your edits, you’ll
          need to start a new signing by requesting signatures again.
        </Paragraph>
      }
      footer={
        <ButtonGroup aria-label="make edits options">
          <TextButton tone="brand" onClick={onEditModalClose} disabled={isFetching || isMutating}>
            Cancel
          </TextButton>
          <Button
            tone="brand"
            emphasis="filled"
            loading={isFetching || isMutating}
            onClick={onYesEditClick}
            disabled={isFetching || isMutating}
          >
            Yes
          </Button>
        </ButtonGroup>
      }
    />
  );
}
